import createYCloudIcon from '../createYCloudIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  [
    'path',
    {
      d: 'M14 4.5a1 1 0 0 1 5 0 .5.5 0 0 0 .5.5 1 1 0 0 1 0 5c-.81 0-1.8-.7-2.5 0l-1.958 1.957a.15.15 0 0 1-.252-.072l-.493-2.07a.15.15 0 0 0-.111-.112l-2.072-.494a.15.15 0 0 1-.072-.252L14 7c.7-.7 0-1.69 0-2.5',
      key: '1c7o5b',
    },
  ],
  ['path', { d: 'm16 20-1-2', key: '5348lt' }],
  ['path', { d: 'm20 16-2-1', key: '2c7pv5' }],
  ['path', { d: 'm4 8 2 1', key: 'rpj1x4' }],
  ['path', { d: 'm8 4 1 2', key: '1r4zbp' }],
  [
    'path',
    {
      d: 'M9.698 14.19a.15.15 0 0 0 .112.112l2.074.489a.15.15 0 0 1 .072.252L10 17c-.7.7 0 1.69 0 2.5a1 1 0 0 1-5 0 .495.495 0 0 0-.5-.5 1 1 0 0 1 0-5c.81 0 1.8.7 2.5 0l1.956-1.957a.15.15 0 0 1 .252.072z',
      key: '3u61yx',
    },
  ],
];

/**
 * @component @name BoneFracture
 * @description YCloud SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aAogICAgZD0iTTE0IDQuNWExIDEgMCAwIDEgNSAwIC41LjUgMCAwIDAgLjUuNSAxIDEgMCAwIDEgMCA1Yy0uODEgMC0xLjgtLjctMi41IDBsLTEuOTU4IDEuOTU3YS4xNS4xNSAwIDAgMS0uMjUyLS4wNzJsLS40OTMtMi4wN2EuMTUuMTUgMCAwIDAtLjExMS0uMTEybC0yLjA3Mi0uNDk0YS4xNS4xNSAwIDAgMS0uMDcyLS4yNTJMMTQgN2MuNy0uNyAwLTEuNjkgMC0yLjUiCiAgLz4KICA8cGF0aCBkPSJtMTYgMjAtMS0yIiAvPgogIDxwYXRoIGQ9Im0yMCAxNi0yLTEiIC8+CiAgPHBhdGggZD0ibTQgOCAyIDEiIC8+CiAgPHBhdGggZD0ibTggNCAxIDIiIC8+CiAgPHBhdGgKICAgIGQ9Ik05LjY5OCAxNC4xOWEuMTUuMTUgMCAwIDAgLjExMi4xMTJsMi4wNzQuNDg5YS4xNS4xNSAwIDAgMSAuMDcyLjI1MkwxMCAxN2MtLjcuNyAwIDEuNjkgMCAyLjVhMSAxIDAgMCAxLTUgMCAuNDk1LjQ5NSAwIDAgMC0uNS0uNSAxIDEgMCAwIDEgMC01Yy44MSAwIDEuOC43IDIuNSAwbDEuOTU2LTEuOTU3YS4xNS4xNSAwIDAgMSAuMjUyLjA3MnoiCiAgLz4KPC9zdmc+Cg==) - https://tianjianjun0727.github.io/ycloud-icons/icons/bone-fracture
 * @see https://tianjianjun0727.github.io/ycloud-icons/guide/react - Documentation
 *
 * @param {Object} props - YCloud icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BoneFracture = createYCloudIcon('bone-fracture', __iconNode);

export default BoneFracture;
